var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGlobalContext } from '@honeycomb/data';
import { Button, MapIcon, Skeleton } from '@honeycomb/ui-core';
import React from 'react';
export function HotelMapButtonMobile(_a) {
    var { onClick, loading } = _a, other = __rest(_a, ["onClick", "loading"]);
    const { resourceStrings: { SRP_MAPBUTTON_LABEL }, } = useGlobalContext();
    if (loading) {
        return (React.createElement(Skeleton, { radius: 10 },
            React.createElement(Button, null, SRP_MAPBUTTON_LABEL)));
    }
    return (React.createElement(Button, Object.assign({ size: "s", color: "primary", variant: "outlined", onClick: onClick, icon: React.createElement(MapIcon, null) }, other), SRP_MAPBUTTON_LABEL));
}
